"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _ReactOverlay = _interopRequireDefault(require("@micado-digital/react-overlay/ReactOverlay"));
var _react2 = require("swiper/react");
require("swiper/css");
require("swiper/css/thumbs");
require("swiper/css/navigation");
require("swiper/css/pagination");
var _Item = _interopRequireDefault(require("./Item"));
var _ReactGallery = _interopRequireDefault(require("./ReactGallery02.styles"));
var _swiper = require("swiper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ReactGallery02 = function ReactGallery02(_ref) {
  var _ref$autoHeight = _ref.autoHeight,
    autoHeight = _ref$autoHeight === void 0 ? false : _ref$autoHeight,
    absoluteMediaURLs = _ref.absoluteMediaURLs,
    _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? false : _ref$bullets,
    elements = _ref.elements,
    mediaFormats = _ref.mediaFormats,
    overlayMediaFormats = _ref.overlayMediaFormats,
    navNext = _ref.navNext,
    navPrev = _ref.navPrev,
    resourceURL = _ref.resourceURL,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? false : _ref$showOverlay,
    _ref$showText = _ref.showText,
    showText = _ref$showText === void 0 ? false : _ref$showText,
    thumbs = _ref.thumbs,
    _ref$webpFallback = _ref.webpFallback,
    webpFallback = _ref$webpFallback === void 0 ? true : _ref$webpFallback,
    SwiperProps = _ref.SwiperProps,
    SwiperThumbsProps = _ref.SwiperThumbsProps;
  var css = (0, _ReactGallery.default)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    mediaID = _useState2[0],
    setMediaID = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    thumbsSwiper = _useState6[0],
    setThumbsSwiper = _useState6[1];
  if (!elements || elements.length === 0) return null;
  if (!(mediaFormats !== null && mediaFormats !== void 0 && mediaFormats.xs)) return null;
  var pagination = false;
  if (bullets) {
    pagination = {
      clickable: true
    };
  }
  var handleClick = function handleClick(id) {
    if (showOverlay) {
      setMediaID(id);
      setOpen(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-gallery-02"
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({
    autoHeight: autoHeight,
    className: (0, _clsx2.default)(css.swiper, "mco-gallery-02-swiper", "swiper-container"),
    grabCursor: showOverlay ? false : true,
    modules: [_swiper.Pagination, _swiper.Navigation, _swiper.Thumbs],
    navigation: {
      prevEl: navPrev ? ".mco-gallery-02-swiper-nav__prev" : undefined,
      nextEl: navNext ? ".mco-gallery-02-swiper-nav__next" : undefined
    },
    pagination: pagination,
    thumbs: {
      swiper: thumbsSwiper
    }
  }, SwiperProps), elements === null || elements === void 0 ? void 0 : elements.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      className: (0, _clsx2.default)("mco-gallery-02-swiper__item", _defineProperty({}, css.slideClickable, showOverlay)),
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_Item.default, {
      absoluteMediaURLs: absoluteMediaURLs,
      data: item,
      mediaFormats: mediaFormats,
      resourceURL: resourceURL,
      showText: showText,
      webpFallback: webpFallback,
      id: index,
      onClick: handleClick
    }));
  }), navPrev && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-gallery-02-swiper-nav__prev", css.swiperNav, css.swiperNavPrev)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navPrev
  })), navNext && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-gallery-02-swiper-nav__next", css.swiperNav, css.swiperNavNext)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navNext
  }))), thumbs && elements.length > 1 && /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({
    centeredSlides: true,
    centerInsufficientSlides: true,
    centeredSlidesBounds: true,
    className: (0, _clsx2.default)("mco-gallery-02-thumb-swiper", css.thumbSwiper),
    modules: [_swiper.FreeMode, _swiper.Navigation, _swiper.Thumbs],
    onSwiper: setThumbsSwiper,
    slidesPerView: "auto",
    spaceBetween: 8,
    watchSlidesProgress: true
  }, SwiperThumbsProps), elements === null || elements === void 0 ? void 0 : elements.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      className: (0, _clsx2.default)("mco-gallery-02-thumb-swiper__item", css.thumbItem),
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_Item.default, {
      absoluteMediaURLs: absoluteMediaURLs,
      data: item,
      resourceURL: resourceURL,
      thumbs: thumbs,
      webpFallback: webpFallback
    }));
  })), open && /*#__PURE__*/_react.default.createElement(_ReactOverlay.default, {
    absoluteMediaURLs: absoluteMediaURLs,
    images: elements,
    imagesPos: mediaID,
    mediaFormats: overlayMediaFormats,
    mode: "images",
    resourceURL: resourceURL,
    setOpen: setOpen
  }));
};
ReactGallery02.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  elements: _propTypes.default.array.isRequired,
  navNext: _propTypes.default.string,
  navPrev: _propTypes.default.string,
  mediaFormats: _propTypes.default.object.isRequired,
  overlayMediaFormats: _propTypes.default.object,
  resourceURL: _propTypes.default.string,
  showOverlay: _propTypes.default.bool,
  showText: _propTypes.default.bool,
  thumbs: _propTypes.default.string,
  webpFallback: _propTypes.default.bool,
  SwiperProps: _propTypes.default.object,
  SwiperThumbsProps: _propTypes.default.object
};
var _default = ReactGallery02;
exports.default = _default;